import { get, getError } from '../client'

const getChannels = async () => await get('channel_offers', true)
const getChannelsAgv = async (agv) => await get(`channel_offers?agv=${agv}`, true)
const getUser = async () => await get('users?current_user=true&expand=true', true)
const getUserOnline = async (agv) => await getError(`users?current_user=true&expand=true&agv=${agv}`, true)
const getUserGroups = async (userId) => await get(`user_groups?users=${userId}`, true)

export { getChannels, getUser, getUserGroups, getUserOnline, getChannelsAgv }
